import styled from 'styled-components';

export const Close = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 10;
  height: 42px;
  width: 42px;
  cursor: pointer;
  transition: 0.15s all ease-in;
  border: 0;
  border-radius: 0 14px 0 0;
  background-color: transparent;
  color: #7a838a;
  svg {
    display: block;
    transition: color 0.15s ease-in;
  }
  &:hover {
    background-color: #cc2936;
    color: #ffffff;
  }
`;

export const Header = styled.div`
  background-color: #0c1210;
  cursor: grab;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  box-sizing: border-box;
  border-top-left-radius: inherit;
  border-top-right-radius: inherit;
  color: #e6eaec;
  font-size: 14px;
  font-weight: 600;
  position: relative;
  height: 42px;
  width: 100%;
  flex-shrink: 0;
  padding-right: 30px;
  border-bottom: 1px solid #2c353d;
  p {
    margin: 0;
  }
`;

export const TabsBox = styled.div`
  /* width: 100%; */
  height: 45px;
  /* padding: 0 15px; */
  box-sizing: border-box;
  /* background-color: #262b31; */
  display: flex;
`;

export const Content = styled.div`
  background-color: #161e23;
  color: #e6eaec;
  border-radius: 0 0 14px 14px;
`;

export const Tab = styled.p`
  cursor: pointer;
  margin: 14px 32px 0 0;
  padding-bottom: 8px;
  font-size: 15px;
  color: ${(props) => (props.active ? '#47b972' : '#aab2b8')};
  border-bottom: ${(props) => (props.active ? 'solid 3px #47b972' : 'solid 3px transparent')};
  font-weight: ${(props) => (props.active ? 600 : 400)};
  transition: color 0.15s ease;
  &:hover {
    color: #47b972;
  }
`;

export const Menu = styled.div`
  width: 100%;
  height: 46px;
  padding: 0 15px;
  box-sizing: border-box;
  background-color: #1a2429;
  border-bottom: 1px solid #2c353d;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
